<template>
  <div class="sidebar-container" :style="{'right':(isShow?'0':'')}">
    <div class="box" @click="$router.push('/')">
      <img src="../assets/image/sidebar-home.png" height="26" width="29"/>
    </div>
    <div class="box phone-box"
         @mousemove="isShowPhone=true"
         @mouseleave="isShowPhone=false"
         :style="{'backgroundColor':(isShowPhone?'#3a4ccc':'')}">
      <img src="../assets/image/sidebar-phone.png" height="30" width="30"/></div>
    <div class="phone-content"
         :style="{'opacity':(isShowPhone?'1':''),'left':(isShowPhone?'-145px':'')}"
         @mousemove="isShowPhone=true"
         @mouseleave="isShowPhone=false">
      {{companyInfo.phone}}
    </div>
    <div class="box wechat-box"
         @mousemove="isShowWechat=true"
         @mouseleave="isShowWechat=false"
         :style="{'backgroundColor':(isShowWechat?'#3a4ccc':'')}">
      <img src="../assets/image/sidebar-wechat.png" height="26" width="30"/>
      <div class="wechat-content"
           :style="{'opacity':(isShowWechat?'1':''),'left':(isShowWechat?'-131px':'')}"
           @mousemove="isShowWechat=true"
           @mouseleave="isShowWechat=false">
        <img :src="$img + companyInfo.wechatImg" height="120" width="120"/></div>
    </div>
    <div class="box" @click="backTop">
      <img src="../assets/image/sidebar-backtop.png" height="24" width="30"/></div>
  </div>
</template>

<script>
  export default {
    name: "sidebar",
    data() {
      return {
        scrollTop: document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset,
        isShow: false,
        isShowPhone: false,
        isShowWechat: false,
        timer:'',
        companyInfo:{}
      }
    },
    created() {
      this.$http.get('/api/company/info/list').then((res)=>{
        // console.log(res.data.rows[0])
        this.companyInfo = res.data.rows[0]
      })
    },
    mounted() {
      if (this.$route.path == '/'||this.$route.path == '/product'||this.$route.path == '/productDetail'){
        window.addEventListener('scroll', this.showSideBar, true)
      }else{
        this.isShow = true
      }
    },
    methods: {
      showSideBar() {
        let scrollTop = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset
        this.scrollTop = scrollTop
        if (scrollTop > 150) {
          this.isShow = true
        } else {
          this.isShow = false
        }
      },
      backTop() {
        const that=this
        let scrollDistance = this.scrollTop / 10
        this.timer = setInterval(function () {
          let scrollTop = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset
          document.documentElement.scrollTop = document.body.scrollTop = scrollTop-scrollDistance
          if (scrollTop==0){
            clearInterval(that.timer)
          }
        }, 20)
      }
    }
  }
</script>

<style scoped>
  .sidebar-container {
    width: 72px;
    height: 288px;
    background-color: #6676e7;
    color: #fff;
    position: fixed;
    right: -100%;
    bottom: 100px;
    transition: right .5s;
    z-index: 11;
  }

  .box {
    width: 100%;
    height: 72px;
    display: flex;
    position: relative;
  }

  .box:hover {
    background-color: #3a4ccc;
  }

  .box img {
    margin: auto;
  }

  .phone-box, .wechat-box {
    position: relative;
  }

  .phone-content {
    width: 144px;
    height: 72px;
    position: absolute;
    background-color: #6676e7;
    left: -136px;
    top: 72px;
    text-align: center;
    line-height: 72px;
    opacity: 0;
    z-index: -1;
    transition: left .5s, opacity .3s;
  }

  .wechat-content {
    width: 130px;
    height: 130px;
    display: flex;
    position: absolute;
    background-color: #6676e7;
    left: -125px;
    top: 0;
    opacity: 0;
    z-index: -1;
    transition: left .5s, opacity .3s;
  }

  .wechat-content img {
    margin: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/sidebar.vue